<div class="w-fill-available flex flex-col gap-2" data-testid="admin-event-analytics-filters">
  <h3 class="text-base">{{ filterTranslationKeyPrefix + '.scope' | translate }}</h3>

  <div class="flex items-center gap-4 w-fill-available">
    <app-profile-date-filter
      class="w-[252px]"
      [campaignAnalytics]="null"
      [allTimeBounds]="allTimeBounds"
      [initialState]="initialDateFilterState"
      [translationKeyPrefix]="filterTranslationKeyPrefix"
      [excludedRangeTypes]="excludedRangeTypes"
      [showCompare]="true"
      (dateRangeChanged)="onDateRangeChanged($event)"
      (compareRangeChanged)="onCompareRangeChanged($event)"
    />

    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="userGroupEmptyLabel()"
      [loading]="userGroupsLoading()"
      [options]="userGroupOptions()"
      [searchPlaceholder]="filterTranslationKeyPrefix + '.searchGroups' | translate"
      [selectedValues]="selectedUserGroupIds()"
      (selectionChanged)="onUserGroupSelectionChanged($event)"
      (panelClosed)="onUserGroupFilterPanelClosed()"
    />
  </div>
</div>
